import * as React from "react";
import { Query, QueryResult, OperationVariables } from "react-apollo";
import { GetUserQuery } from "../../__generated__/types";
import { USER_QUERY } from "./queries";

export class ProfileQuery extends Query<GetUserQuery> {}

interface Props {
  children(
    props: QueryResult<GetUserQuery, OperationVariables>
  ): JSX.Element | null;
}

export default ({ children }: Props) => {
  return (
    <ProfileQuery query={USER_QUERY}>{result => children(result)}</ProfileQuery>
  );
};



// WEBPACK FOOTER //
// ./src/queries/ProfileQuery/ProfileQuery.tsx